import React from "react";
import { InputAdornment, TextField, Tooltip } from "@mui/material";

export default function FramerateField({ value, onChange, error, max = 60, disabled = false, size }: { value: string | number; onChange: (value: string) => void; error?: string; max?: number; disabled?: boolean; size?: "small" | "medium" }) {
  return <Tooltip title={`Valid range: 1-${max} fps. Examples: 30, 29.97, 23.976.`} arrow>
    <TextField label="Framerate" value={value} onChange={(event) => onChange(event.target.value)}
      disabled={disabled} fullWidth size={size} error={Boolean(error)} helperText={error || undefined}
      slotProps={{
        htmlInput: { inputMode: "decimal" },
        input: { endAdornment: <InputAdornment position="end">fps</InputAdornment> },
      }} />
  </Tooltip>;
}
